import React, { createContext, useContext, useState, useEffect } from 'react';
import { apiService } from '../Services/apiService';
import { useAuth } from './AuthContext';

const QuestionContext = createContext();

export const QuestionProvider = ({ children }) => {
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      fetchQuestions();
    } else {
      setQuestions([]);
    }
  }, [user]);

  const fetchQuestions = async () => {
    try {
        const data = await apiService.getAllQuestions();
        setQuestions(data);
    } catch (err) {
        console.error("Failed to fetch questions", err);
        import('sweetalert2').then(Swal => {
            Swal.default.fire({
                icon: 'error',
                title: 'Hata',
                text: `Soru havuzu yüklenirken hata oluştu: ${err.message}`
            });
        });
    } finally {
        setLoading(false);
    }
  };

  const addQuestion = async (newQuestion) => {
    try {
        console.log('[QuestionContext] addQuestion called with:', newQuestion);
        const savedQuestion = await apiService.createQuestion(newQuestion);
        console.log('[QuestionContext] API response:', savedQuestion);
        setQuestions(prev => [...prev, savedQuestion]);
        console.log('[QuestionContext] State updated');
        return savedQuestion; // Return for immediate use
    } catch (err) {
        console.error('[QuestionContext] Failed to add question:', err);
        throw err;
    }
  };

  const deleteQuestion = async (id) => {
    try {
        await apiService.deleteQuestion(id);
        setQuestions(prev => prev.filter(q => q.id !== id));
    } catch (err) {
        console.error("Failed to delete question", err);
    }
  };

  const updateQuestion = async (id, updatedData) => {
    try {
        const result = await apiService.updateQuestion(id, updatedData);
        setQuestions(prev => prev.map(q => q.id === id ? result : q));
    } catch (err) {
        console.error("Failed to update question", err);
    }
  };

  return (
    <QuestionContext.Provider value={{ 
      questions, 
      loading, 
      addQuestion, 
      deleteQuestion, 
      updateQuestion 
    }}>
      {children}
    </QuestionContext.Provider>
  );
};

export const useQuestions = () => useContext(QuestionContext);
